// One visual contract for the V3 composer's pill triggers — the approval
// mode control and the model picker — so the set reads as one design and
// cannot drift apart. The colorway is separate because the approval
// control swaps it per mode; each control adds only its own content
// modifiers (chevron hooks, truncation).
export const COMPOSER_PILL_TRIGGER_CLASSES =
    'focus-visible:outline-agent-action inline-flex h-7 shrink-0 items-center gap-1 rounded-full border px-2.5 text-v3-chat-meta leading-none whitespace-nowrap shadow-[0_1px_0_rgba(0,0,0,0.04)] transition-[background-color,box-shadow] duration-[120ms] outline-none focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-[0.42] motion-reduce:transition-none';

export const COMPOSER_PILL_QUIET_CLASSES =
    'border-border bg-background text-foreground/85 hover:bg-muted/80 data-[state=open]:bg-muted/80';
